<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/DanKNc/tc-custom/9781504096607.jpg?1726483131857" alt="This image is the cover for the book Second Chances at the Little Love Café"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Second Chances at the Little Love Café
      </h1>
      <p class="bookDescription body article font2">
        <b>From the author of <i>The Car Share</i>: Her broken heart is bad for business—but can a partnership with her first love save the day?</b><br/><br/> If she’s honest, Alice has stopped believing in the power of love. . . . Finding your fiancé in bed with a woman he met during his bachelor party will do that.<br/><br/> So, when Alice’s first love, Noah—the one who got away—reappears in her seaside hometown after more than twenty years, the cynical single mom doesn’t know how to feel.<br/><br/> However, when Alice and Noah are left in charge of The Little Love Café while the owner goes abroad, her jaded attitude has a negative effect on the business. And soon, the #heartbreakcafe threatens to start trending.<br/><br/> She’s on a sure path to self-destruction, a family feud is brewing, and the café is in peril. Can anyone help them turn things around? Or is The Little Love Café doomed to close its doors for a final time?<br/><br/><b>Praise for Lucy Mitchell</b><br/><br/> “[Mitchell’s] writing is deliciously funny and has so much heart.” —Sandy Barker, author of <i>One Summer in Santorini</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lucy Mitchell
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?76b14f47